import React from 'react'
import HeaderStats from './HeaderStats'

const MainMeAll = () => {
  return (
    <div>
      <HeaderStats />
    </div>
  )
}

export default MainMeAll
